import ImageResultAvc from '../../../assets/img/ResultAvc.jpg'
import ImageResultCancerBreast from '../../../assets/img/ResultCancerBreast.jpg'
import ImageResultCancerFoie from '../../../assets/img/ResultCancerFoie.jpg'
import ImageResultCancerThroat from '../../../assets/img/ResultCancerThroat.jpg'
import ImageResultCardiacTrouble from '../../../assets/img/ResultCardiacTrouble.jpg'
import ImageResultColorectal from '../../../assets/img/ResultColorectal.jpg'
import ImageResultHyperTension from '../../../assets/img/ResultHyperTension.jpg'
import ImageResultOesophage from '../../../assets/img/ResultOesophage.jpg'
import ImageResultToxicite from '../../../assets/img/ResultToxicite.jpg'

export const CELLULAR_TOXICITY = {
  label: 'Toxicité cellulaire',
  key: 'toxicity',
  image: ImageResultToxicite,
  title: '',
  subtitle:
    "Toute consommation d'alcool détériore les cellules de votre organisme et peut provoquer des maladies.",
  resultField: 'toxCel',
  percentageRisk: false,
}
export const BREAST_CANCER = {
  label: 'Cancer du sein',
  key: 'breast_cancer',
  image: ImageResultCancerBreast,
  title: '+[value]% de risque',
  subtitle: "Toute consommation d'alcool comporte des risques de cancers.",
  resultField: 'kSein',
  percentageRisk: true,
}
export const MOUTH_CANCER = {
  label: 'Cancer de la bouche, du pharynx et du larynx',
  key: 'mouth_cancer',
  image: ImageResultCancerThroat,
  title: '+[value]% de risque',
  subtitle: "Toute consommation d'alcool comporte des risques de cancers.",
  resultField: 'kBouchePhxLarx',
  percentageRisk: true,
}
export const THROAT_CANCER = {
  label: "Cancer de l'oesophage",
  key: 'throat_cancer',
  image: ImageResultOesophage,
  title: '+[value]% de risque',
  subtitle: "Toute consommation d'alcool comporte des risques de cancers.",
  resultField: 'kOesophage',
  percentageRisk: true,
}
export const COLORECTAL_CANCER = {
  label: 'Cancer colorectal',
  key: 'colorectal_cancer',
  image: ImageResultColorectal,
  title: '+[value]% de risque',
  subtitle: "Toute consommation d'alcool comporte des risques de cancers.",
  resultField: 'kColonRectum',
  percentageRisk: true,
}
export const LIVER_CANCER = {
  label: 'Cancer du foie',
  key: 'liver_cancer',
  image: ImageResultCancerFoie,
  title: '+[value]% de risque',
  subtitle: "Toute consommation d'alcool comporte des risques de cancers.",
  resultField: 'kFoie',
  percentageRisk: true,
}
export const CARDIAC_TROUBLES = {
  label: 'Troubles du rythme cardiaque',
  key: 'cardiac_troubles',
  image: ImageResultCardiacTrouble,
  title: '',
  subtitle:
    "Votre consommation d'alcool augmente vos risques de développer des irrégularités du rythme cardiaque.",
  resultField: 'fa',
  percentageRisk: false,
}
export const AVC = {
  label: 'AVC hémorragique',
  key: 'avc',
  image: ImageResultAvc,
  title: '',
  subtitle:
    "Votre consommation d'alcool augmente vos risques d'avoir un AVC (Accident Vasculaire Cérébral) hémorragique.",
  resultField: 'avcHemo',
  percentageRisk: false,
}
export const HYPERTENSION = {
  label: 'Hypertension artérielle',
  key: 'hypertension',
  image: ImageResultHyperTension,
  title: '',
  subtitle:
    "Votre consommation d'alcool augmente vos risques d'avoir de l'hypertension artérielle. Cela peut provoquer, entre autres, des maladies cardiovasculaires.",
  resultField: 'hta',
  percentageRisk: false,
}

export interface IResultsRisks {
  label: string
  key: string
  image: string
  title: string
  subtitle?: string
  pretitle?: string
  resultField: string
  percentageRisk: boolean
}

export const womanRisks = [
  BREAST_CANCER,
  MOUTH_CANCER,
  THROAT_CANCER,
  COLORECTAL_CANCER,
  LIVER_CANCER,
  AVC,
  HYPERTENSION,
  CARDIAC_TROUBLES,
  CELLULAR_TOXICITY,
]

export const manRisks = [
  COLORECTAL_CANCER,
  THROAT_CANCER,
  MOUTH_CANCER,
  LIVER_CANCER,
  AVC,
  HYPERTENSION,
  CARDIAC_TROUBLES,
  CELLULAR_TOXICITY,
]



// WEBPACK FOOTER //
// ./src/components/ResultsComponents/ResultsRisks/ResultsRisks.ts